
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"fill":"#D0EFEC","d":"M23.65 5.34 8.46 10.46v12.56c0 10.76 15.14 19.6 15.23 19.65z"}}),_c('path',{staticClass:"i-Vector",attrs:{"stroke":"#234652","d":"M24.158 45.085q-.316.197-.507.312a51.758 51.758 0 0 1-2.472-1.635 56 56 0 0 1-6.012-4.874C10.772 34.758 6.5 29.178 6.5 23.15V8.92l17.152-5.773L41.15 8.922V23.16c0 5.974-4.353 11.55-8.84 15.693a57.4 57.4 0 0 1-8.153 6.232Z"}})])
          )
        }
      }
    